<template><section><h1>Messsage 文字提示</h1>
<h2>基本用法</h2>
<demo-block>
                    <div class="source" slot="source"><nt-button type="primary" @click="success">success</nt-button>
<nt-button type="warn" @click="warn">warn</nt-button>
<nt-button type="danger" @click="danger">danger</nt-button>

</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"success"</span>&gt;</span>success<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"warn"</span>    <span class="hljs-attr">@click</span>=<span class="hljs-string">"warn"</span>&gt;</span>warn<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"danger"</span>  <span class="hljs-attr">@click</span>=<span class="hljs-string">"danger"</span>&gt;</span>danger<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-attr">methods</span>: {
        success() {
            <span class="hljs-keyword">this</span>.$ntMessageShow({
                <span class="hljs-attr">content</span>: <span class="hljs-string">'这是一条成功的提示'</span>
            });
        },
        warn() {
            <span class="hljs-keyword">this</span>.$ntMessageShow({
                <span class="hljs-attr">type</span>: <span class="hljs-string">'warn'</span>,
                <span class="hljs-attr">content</span>: <span class="hljs-string">'这是一条警告的提示'</span>
            });
        },
        danger() {
            <span class="hljs-keyword">this</span>.$ntMessageShow({
                <span class="hljs-attr">type</span>: <span class="hljs-string">'danger'</span>,
                <span class="hljs-attr">content</span>: <span class="hljs-string">'这是一条危险的提示'</span>
            });
        },
    }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">type</td>
<td style="text-align:left">提示类型</td>
<td style="text-align:left">String</td>
<td style="text-align:left"><code v-pre>success</code> <code v-pre>danger</code>  <code v-pre>warn</code></td>
<td style="text-align:left"><code v-pre>success</code></td>
</tr>
<tr>
<td style="text-align:left">duration</td>
<td style="text-align:left">显示多少秒后自动关闭</td>
<td style="text-align:left">Number</td>
<td style="text-align:left">-</td>
<td style="text-align:left">3(单位为s)</td>
</tr>
<tr>
<td style="text-align:left">content</td>
<td style="text-align:left">显示的内容</td>
<td style="text-align:left">String</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
    methods: {
        success() {
            this.$ntMessageShow({
                content: '这是一条成功的提示'
            });
        },
        warn() {
            this.$ntMessageShow({
                type: 'warn',
                content: '这是一条警告的提示'
            });
        },
        danger() {
            this.$ntMessageShow({
                type: 'danger',
                content: '这是一条危险的提示'
            });
        },
    }
}
</script>